import styles from "./style.module.scss";
interface VLCountProps {
  count: number;
}
export default function VLCount({ count }: VLCountProps) {
  return <div className={styles.wrapper}>{count}</div>;
}
